export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	tornadustherian: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	thundurustherian: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	landorustherian: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	kyuremblack: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	kyuremwhite: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	keldeo: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	keldeoresolute: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	meloetta: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	genesect: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
};
